import React, { useEffect } from 'react';
import { useRouter } from 'expo-router';
import { View } from 'react-native';
import { useAuth } from '@/contexts/AuthContext';
import { biometricService } from '@/services/biometricService';

export default function Index() {
  const router = useRouter();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (loading) return;

    let cancelled = false;

    const route = async () => {
      console.log('✅ Auth resolved, navigating immediately...');

      // Active session already restored → straight into the app.
      if (user) {
        router.replace('/diary');
        return;
      }

      // No active session. If this device has biometric login enrolled with a
      // stored session, send the returning user to the login screen — which
      // auto-triggers the biometric (Face ID / fingerprint) prompt — instead of
      // the generic welcome page where biometric is never offered.
      try {
        const [enabled, stored] = await Promise.all([
          biometricService.isEnabled(),
          biometricService.getStoredSession(),
        ]);
        if (cancelled) return;
        if (enabled && stored) {
          router.replace('/login');
          return;
        }
      } catch {
        // Biometric check failed — fall through to the welcome page.
      }

      if (!cancelled) {
        router.replace('/welcome');
      }
    };

    route();

    return () => {
      cancelled = true;
    };
  }, [user, loading, router]);

  // Show minimal transparent loading state - NO BLACK SCREEN!
  return <View style={{ flex: 1, backgroundColor: 'transparent' }} />;
}